// extracted by mini-css-extract-plugin
export default {"fade-in":"bIS5yxBZ3jllkgoJHLP2","fadeIn":"bIS5yxBZ3jllkgoJHLP2","fadein":"yCZCHGHGqWTwS3X0yhrC","primary-header":"NbAoDAWAg4oKYnMu9CgF","primaryHeader":"NbAoDAWAg4oKYnMu9CgF"};